import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import gtag from "ga-gtag";
import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import Newsdetails from "./components/pages/newsdetails";
import SinglePage from "./components/pages/SinglePage";
import ModalComponent from "./components/popmodel/ModalComponent";
import configData from "../src/config.json";
import enquireLogo from "../src/assets/imgs/enquire3.png";
import axios from "axios";

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isApiChecked, setIsApiChecked] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      const isModalShown = sessionStorage.getItem("isModalShown");
      if (!isModalShown) {
        setIsModalOpen(true);
        sessionStorage.setItem("isModalShown", "true");
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleWhatappGtag = () => {
    gtag("event", "FloatWhatsapp", {
      section_name: "WhatsappFloat",
    });
  };

  function clearBrowserCache() {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });
    if ("caches" in window) {
      caches.keys().then(function (names) {
        for (let name of names) {
          caches.delete(name);
        }
      });
    }
  }

  const callapi = async () => {
    try {
      let res = await axios.get(`${configData.API_URL}page`);
      const allPages = await res.data.data;
      const currentPath = window.location.pathname.split("/")[1];
      const matchingInactive = await allPages.find(
        (item) => item.status === "INACTIVE" && item.sku === currentPath
      );

      const nonMatchingSkus =
        currentPath !== "" &&
        !allPages.some(
          (item) => item.sku !== "page_not_found" && item.sku === currentPath
        );

      if (matchingInactive || nonMatchingSkus) {
        navigate("/page_not_found");
      }

      setIsApiChecked(true);
    } catch (err) {
      console.error("Error fetching data:", err);
      setIsApiChecked(true);
    }
  };
  useEffect(() => {
    callapi();
  }, [location.pathname]);

  return (
    <>
      {isApiChecked && (
        <Routes>
          <Route path="/news/:newsurl" element={<Newsdetails />} />
          <Route path="*" element={<SinglePage />} />
        </Routes>
      )}

      {location.pathname !== "/enquire-now" && (
        <a
          href="https://bydautoindia.com/enquire-now"
          className="floating_button enquireLogobox"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={enquireLogo} className="enquireLogo whatsapp_float" />
        </a>
      )}
      <a
        href="https://wa.me/917303950845?text=hello"
        className="whatsapp_float"
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleWhatappGtag}
      >
        <div className="whatsapp_icon_wrapper">
          <FontAwesomeIcon icon={faWhatsapp} className="whatsapp-icon" />
        </div>
      </a>
      <ModalComponent isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
}
export default App;
